<template>
<div>
    <v-card flat>
        <v-sheet min-height="55vh" rounded="lg">
            <v-card color="grey lighten-4" outlined >
                <v-card-title class="text-h5 ">
                    Solicitação de exame(s) laboratório
                    <v-spacer />
                    <!-- <v-btn color="success" class="mr-2" @click="isNovoExame = true">
                                Novo exame
                                <v-icon right>
                                    add
                                </v-icon>
                            </v-btn> -->

                    <!-- <v-btn color="orange lighten-3" @click="isNovo = true">
                novo modelo de solicitação
                <v-icon right>
                    add
                </v-icon>
            </v-btn> -->

                </v-card-title>

                <v-card-text>
                    <v-autocomplete class="pb-0 mb-0" solo white v-model="solicitacao" :items="solicitacoes" :loading="isLoading" :search-input.sync="search" hide-no-data hide-selected item-text="nome" item-value="API" label="Meus modelos" placeholder="Buscar modelo" prepend-icon="mdi-database-search" return-object></v-autocomplete>
                    <v-autocomplete class="mt-0 mt-0" solo @change="searchExame = ''" v-model="exame1" :items="items" :loading="isLoading" :search-input.sync="searchExame" white hide-no-data hide-selected item-text="apelido" item-value="API" label="Buscar exames" placeholder="Buscar exame" prepend-icon="mdi-database-search" return-object></v-autocomplete>
                    <!-- <v-autocomplete v-if="!isNovo" class="mt-0 mt-0" solo @change="searchExame = ''" v-model="exame1" :items="items" :loading="isLoading" :search-input.sync="searchExame" white hide-no-data hide-selected item-text="apelido" item-value="API" label="Buscar exames" placeholder="Buscar exame" prepend-icon="mdi-database-search" return-object></v-autocomplete> -->
                </v-card-text>
                <!-- {{ solicitacoesExames }} -->
                <!-- <v-divider></v-divider> -->
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" v-show="solicitacoesExames.length > 0" @click="solicitacoesExames = []" outlined>
                        Limpar
                        <v-icon left>mdi-broom</v-icon>
                    </v-btn>
                </v-card-actions>
                <v-card v-if="solicitacoesExames.length > 0" class="mx-2 mb-2">
                    <!--v-list>
                              <v-list-group v-for="(item, j) in mSolicitacoes" :key="item._id" no-action>
                                <template v-slot:activator>
                                  <v-list-item-content>
                                    <v-list-item-title v-text="item.nome"></v-list-item-title>
                                  </v-list-item-content>
                                </template>

                                <v-list-item dense v-for="(field, i) in item.prescricoes" :key="field.idExame" :value="true" no-action sub-group>
                                  <v-list-item-content>
                                    <v-list-item-title v-text="field.nome"></v-list-item-title>
                                  </v-list-item-content>
                                  <v-list-item-action>
                                    <v-checkbox @click="removerExame(j, i)" :input-value="field.imprime" color="primary"></v-checkbox>
                                  </v-list-item-action>
                                </v-list-item>
                              </v-list-group>

                            </v-list-->
                            <v-chip
                            v-for="(field, i) in solicitacoesExames" :key="field.idExame"
                              class="ma-1"
                              color="dark"
                              outlined
                              close
                              label
                              @click:close="solicitacoesExames.splice(i, 1)"
                            >
                            <strong> {{ field.apelido }} </strong>
                            </v-chip>
                    <!-- <v-list dense>
                        <v-list-item dense v-for="(field, i) in solicitacoesExames" :key="field.idExame" :value="true" no-action sub-group>
                            <v-list-item-content>
                                <v-list-item-title v-text="field.apelido"></v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-icon color="red" @click="solicitacoesExames.splice(i, 1)">delete</v-icon>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list> -->
                </v-card>

            </v-card>

           </v-sheet>
        <v-card-actions>
                <v-spacer />
                <v-btn :disabled="load" x-large text color="red" dark @click="$emit('cancelar')">
                    <v-icon left>
                        cancel
                    </v-icon>
                    voltar
                </v-btn>
                <v-btn :loading="load" :disabled="solicitacoesExames.length == 0" x-large color="primary" @click="addSolicitacoesCard">
                    <v-icon left>
                        print
                    </v-icon>
                    Salvar
                </v-btn>
            </v-card-actions>
    </v-card>
</div>
</template>

<script>
import medicoService from '../../services/medico.service'
import administradorUnidadeService from '../../services/administradorUnidade.service'
import {
  jsPDF
} from 'jspdf'
import {
  applyPlugin
} from 'jspdf-autotable'
applyPlugin(jsPDF)

export default {
  name: 'prescricao',
  props: {
    paciente: {
      type: Object
    },
    isEditSolicitacaoLaboratorio: {
      type: Boolean,
      default: false
    },
    mExames: []
  },
  data: () => ({
    descriptionLimit: 60,
    entries: [],
    load: false,
    dadosProntuario: [],
    dialog: false,
    isLoading: false,
    isDescricao: false,
    descricao: '',
    solicitacao: [],
    isNovo: false,
    // isNovoExame: false,
    solicitacoes: [],
    mSolicitacoes: [],
    solicitacoesExames: [],
    mPrescricoes: [],
    model: null,
    exames: [],
    // examesS: [],
    exame1: '',
    user: null,
    values: null,
    searchExame: '',
    search: '',
    nomeExame: '',
    successCadastroExame: 0
  }),

  computed: {
    fields () {
      if (!this.model) return []

      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || 'n/a'
        }
      })
    },
    /* items () {
      return this.entries
        .filter(entry =>
          !this.solicitacoesExames.some(exame => exame.idExame === entry.idExame)
        )
        .map(entry => {
          const Description = entry.nome.length > this.descriptionLimit
            ? entry.nome.slice(0, this.descriptionLimit) + '...'
            : entry.nome
          return Object.assign({}, entry, { Description })
        })
    } */
    items () {
      return this.entries.filter(entry =>
        !this.solicitacoesExames.some(exame => exame.idExame === entry.idExame)
      ).map(entry => {
        const Description = entry.nome.length > this.nome
          ? entry.nome.slice(0, this.descriptionLimit) + '...'
          : entry.nome
        return Object.assign({}, entry, {
          Description
        })
      })
    }

  },
  methods: {

    removerExame (j, i) {
      this.mSolicitacoes[j].prescricoes[i].imprime = !this.mSolicitacoes[j].prescricoes[i].imprime
      // this.mSolicitacoes[j].prescricoes[i] = null
      // console.log(this.mSolicitacoes[j].prescricoes[i].imprime)
    },
    addSolicitacoesCard () {
      //  console.log('-------------', 'solicitacoesCard', this.solicitacoesExames)
      if (this.isEditSolicitacaoLaboratorio) {
        this.$emit('editarSolicitacoesCard', this.solicitacoesExames, true)
      } else {
        this.$emit('solicitacoesCard', this.solicitacoesExames, true)
      }
      
    },
    imprimirSolicitacao () {
      let exames = this.solicitacoesExames

      if (exames.length > 0) {
        const doc = new jsPDF()

        doc.text(`Paciente: ${this.paciente.nomePaciente}`, 10, 10)
        doc.text(`Solicitante: ${this.user.nome}`, 10, 17)
        // doc.text(20, 20, 'Paciente: ')
        doc.setFont('courier')

        doc.autoTable({
          columns: [{
            header: 'Exame(s)',
            dataKey: 'nome'
          }],
          body: exames,
          margin: {
            top: 25
          }
        })
        // doc.t('Hello world!', 10, 10)
        doc.setLineWidth(0.01).line(0.5, 1.1, 8.0, 1.1)

        // doc.autoPrint()
        window.open(doc.output('bloburl'))
      }
    },

    addSolicitacao_ (data) {
      let isExames = false
      // let exames = []
      this.mSolicitacoes.forEach(s => {
        if (s._id === data._id) isExames = true
      })
      if (!isExames) {
        this.mSolicitacoes.push(data)
        for (let i = 0; i < this.mSolicitacoes.length; i++) {
          const s = this.mSolicitacoes[i]
          s.prescricoes.forEach(e => {
            this.mPrescricoes.push(e)
            // this.sExames.push(e)
          })
        }
      }
      this.$emit('solicitacoes', this.solicitacoesExames)
    },
    addSolicitacao (data, tipo) {
      let isExames = false
      // let exames = []
      if (this.solicitacoesExames.length > 0) {
        if (tipo == 1) {
          var eAux = null
          console.log(data)
          data.exames.forEach(s => {
            this.solicitacoesExames.forEach(e => {
              eAux = s
              console.log(e, s.idExame)
              console.log(e.idExame == s.idExame)
              if (e.idExame == s.idExame) isExames = true
            })
            if (!isExames) {
              this.solicitacoesExames.push(eAux)
              isExames = false
            }
          })
        } else {
          this.solicitacoesExames.forEach(s => {
            if (s.idExame == data.idExame) isExames = true
          })
          if (!isExames) {
            this.solicitacoesExames.push(data)
            isExames = true
          }
        }
      }
      if (!isExames) {
        if (tipo == 1) {
          data.exames.forEach(e => {
            console.log(e)
            this.solicitacoesExames.push(e)
          })
        } else {
          this.solicitacoesExames.push(data)
        }
      }
      this.$emit('solicitacoes', this.mSolicitacoes)
    },

    addExame (data) {
      let isExame = false
      this.exames.forEach((e, i) => {
        if (e.idExame == data.idExame) {
          isExame = true
        }
      })
      if (!isExame) {
        this.exames.push(data)
        this.model = null
        this.search = null
      }
    },
    listarExames (nome) {
      let exames = null
      this.isLoading = true
      medicoService.medico.listarExamesPorNome(nome, 'LABORATORIO').then(r => {
        if (r.status == 200) {
          console.log('AAAAAAA: ', r.data)
          this.count = r.data.length
          this.entries = r.data
        }
      }).finally(() => {
        this.isLoading = false
      })
      return exames
    },
    removerSolicitacao (solicitacao) {
      this.load = true
      let mExames = []
      this.exames.forEach(e => {
        e.imprime = true
        mExames.push(e)
      })
      medicoService.medico.cadastrarSolicitacaoExame({
        idUsuario: this.user.id,
        solicitacao: solicitacao,
        isRemove: true
      }).then(r => {

      }).finally(() => {
        this.load = false
        this.listarSolicitacoes()
      })
    },
    cadastrarSolicitacaoExame () {
      this.load = true
      let mExames = []
      this.exames.forEach(e => {
        e.imprime = true
        mExames.push(e)
      })
      medicoService.medico.cadastrarSolicitacaoExame({
        idUsuario: this.user.id,

        solicitacao: {
          prescricoes: mExames,
          nome: this.descricao
        },
        isRemove: false
      }).then(r => {
        this.exames = []
        this.descricao = ''
        this.searchExame = ''
        this.listarSolicitacoes()
      }).finally(() => {
        this.load = false
        // this.isNovo = false
      })
    },
    listarSolicitacoes () {
      medicoService.medico.listarSolicitacoesExames(this.user.id).then(r => {
        if (r.status == 200) {
          this.solicitacoes = r.data
        } else {
          this.solicitacoes = []
        }
      })
    },
    salvar (data) {
      data.exames = this.values
      this.$emit('addReceita', data, true)
    },
    cadastrarExameMedicoSolicitacao (nome) {
      console.log(nome)
      medicoService.medico.cadastrarExameMedicoSolicitacao({
        idMedico: this.user.id,
        nome: nome
      }).then(r => {
        console.log('--------: ', r.status)
        if (r.status === 200) {
          this.successCadastroExame = 1
        } else {
          this.successCadastroExame = 2
        }
      }).finally(() => {
        this.nomeExame = ''
      })
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    this.listarSolicitacoes()
    if (this.mExames.length > 0) {
      this.solicitacoesExames = this.mExames
    }
    // this.dadosProntuario = this.$store.getters.prontuario
    // if (this.dadosProntuario.idAtendimento != null && this.dadosProntuario.idAtendimento == this.paciente.idAtendimento) {
    //  if ( this.dadosProntuario.mSolicitacoes != null && this.dadosProntuario.mSolicitacoes.length > 0) {
    //   this.mSolicitacoes = this.dadosProntuario.mSolicitacoes
    //  }
    // } else {
    //   this.$store.dispatch('updateProntuario', {
    //     idAtendimento: '',
    //     conteudoLaudo: '',
    //     mSolicitacoes: []
    //   })
    // }
    this.dadosProntuario = this.$store.getters.prontuario
    if (this.dadosProntuario.length > 0) {
      for (let i = 0; i < this.dadosProntuario.length; i++) {
        const d = this.dadosProntuario[i]
        if (this.paciente.idAtendimento == d.idAtendimento) {
          if (d.mSolicitacoes != null) this.mSolicitacoes = d.mSolicitacoes
          break
        }
      }
    }
  },
  watch: {
    solicitacoesExames (val) {
      this.$nextTick(() => {
        this.searchExame = ''
        this.exame1 = ''
      })

      // console.log(this.searchExame)
    },
    /*
                    solicitacoesExames (val) {
                        if (this.dadosProntuario.length > 0) {
                        let index = null
                        this.dadosProntuario.forEach((d, i) => {
                            if (this.paciente.idAtendimento == d.idAtendimento) {
                            // console.log(d, i)
                            index = i
                            }
                        })
                        if (index != null) {
                            // console.log('2')
                            this.dadosProntuario[index].idAtendimento = this.paciente.idAtendimento
                            this.dadosProntuario[index].solicitacoes = val
                            this.$store.dispatch('updateProntuario', this.dadosProntuario)
                        }
                        } else {
                        // console.log('3')
                        this.dadosProntuario.push({
                            idAtendimento: this.paciente.idAtendimento,
                            solicitacoes: val
                        })
                        this.$store.dispatch('updateProntuario', this.dadosProntuario)
                        }
                        // this.$emit('conteudoProntuario', val)
                    }, */
    exames (val) {
      if (this.exames.length == 0) this.isDescricao = false
    },
    solicitacao (val) {
      this.addSolicitacao(val, 1)
    },
    exame1 (val) {
      if (val != '') {
        this.addSolicitacao(val, 0)
      }
    },
    model (val) {
      console.log(val)
      if (val != null) {
        this.addExame(val)
      }
    },
    searchExame (val) {
      // Items have already been loaded
      // if (val =! null && val != '') {
      // if (this.items.length > 0) return

      // Items have already been requested
      // if (this.isLoading) return

      // this.isLoading = true
      if (val != null && val != '') this.listarExames(val)
      // Lazily load input items
      // fetch('https://api.publicapis.org/entries')
      //   .then(res => res.json())
      //   .then(res => {
      //     const { count, entries } = res
      //     this.count = count
      //     this.entries = entries
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
      //   .finally(() => (this.isLoading = false))
    }
    // }
  }
}
</script>
